import React from 'react';
import {styled} from '@mui/material';
import {
  Body,
  Headline,
  designSystemToken,
} from '@lightricks/react-design-system';
import {getPriceCurrency} from '@contentlab/views/contentlab/pricing/utils';
import translate from '@/utils/translate';
import ContentLabPlanBundle from '@/types/models/pricing/contentLabPlanBundle';
import Conditional from '@/components/conditional';
import styles from './PriceSection.module.scss';

type PriceProps = {
  bundle: ContentLabPlanBundle;
  currency: string;
  price: number | undefined;
  originalPrice: number | undefined;
  isTrialFeatureEnabled?: boolean;
};

function Price({
  bundle,
  currency,
  price,
  isTrialFeatureEnabled = false,
  originalPrice = undefined,
}: PriceProps) {
  if (bundle === ContentLabPlanBundle.ENTERPRISE) {
    return (
      <Headline className={styles.priceSection} size="xl">
        {translate('Let’s talk')}
      </Headline>
    );
  }

  const priceCurrency = getPriceCurrency(currency, price);

  const LimitedOfferHeadline = styled(Headline)({
    color: designSystemToken('semantic.fg.brand'),
  });

  if (isTrialFeatureEnabled) {
    return (
      <div className={styles.price}>
        <LimitedOfferHeadline className={styles.launchPrice} size="xl">
          {getPriceCurrency(currency, 0)}
        </LimitedOfferHeadline>
        <Body size="xl" className={styles.period}>
          {translate('/ 7 Days')}
        </Body>
      </div>
    );
  }

  return (
    <div className={styles.price}>
      <Conditional condition={originalPrice !== undefined}>
        <Headline className={styles.discountedPrice} size="xl">
          {getPriceCurrency(currency, originalPrice)}
        </Headline>
        <div className={styles.priceGap} style={{width: '8px'}} />
      </Conditional>
      <Headline size="xl">{priceCurrency}</Headline>
      <Body size="xl" className={styles.period}>
        {translate('/per month')}
      </Body>
    </div>
  );
}

export default Price;
